import { savedDisplayOperationState } from "../../hooks/useDisplayOperation";
import { DefaultValue } from "recoil";
import { getCrossContentsByPresetId } from "../../components/crosssection/FPECrossSection";

const csContentsPresetEffect = (contentsID) => async ({trigger, setSelf, getLoadable}) => {
  if (trigger !== 'get') return;

  const savedState = getLoadable(savedDisplayOperationState).contents;
  const contents = await getCrossContentsByPresetId(contentsID);

  if(savedState[contentsID]) {
    const execFunc = async () => {
      return new Promise(resolve => {
        setTimeout(() => {
          const state = savedState[contentsID];
          contents[state.function](state.value);
          resolve(state.value);
        });
      });
    };
    const v = await execFunc();
    setSelf(v);
  } else {
    setSelf(new DefaultValue());
  }
};


export default csContentsPresetEffect;